import { Utils } from '../../Utils/utils';

export class NotificationHistoryRequest {
  body!: NotificationHistoryRequestBody;

  constructor(login: string, options?: Partial<NotificationHistoryRequestOptions>) {
    this.body = new NotificationHistoryRequestBody(login, options);
  }
}

export interface NotificationHistoryRequestOptions {
  deviceTokenId: string;
  id: string;
  created: string;
  dcMethod: 'QUERY' | 'UPDATE' | 'GETUNREADLIST' | 'UNREADCOUNT';
  pageSize: number;
  startRowNum: number;
  newQuery: boolean;
  noDays: number;
}

export class NotificationHistoryRequestBody {
  ProcessName = 'DC Notification History Wrapper WF';
  DCMethod = 'QUERY';
  IncomingHierarchy: NotificationHistoryIncomingHierarchy;
  Language = 'ENU';
  PageSize = 50;
  StartRowNum = 0;
  NewQuery = true;
  NoDays = 50;

  constructor(login: string, options?: Partial<NotificationHistoryRequestOptions>) {
    this.IncomingHierarchy = new NotificationHistoryIncomingHierarchy(login, options);
    this.DCMethod = options?.dcMethod ?? 'QUERY';
    this.PageSize = options?.pageSize ?? 50;
    this.StartRowNum = options?.startRowNum ?? 0;
    this.NewQuery = options?.newQuery ?? true;
    this.NoDays = options?.noDays ?? 50;
  }
}

export class NotificationHistoryIncomingHierarchy {
  MessageId = Utils.generateUniqueId();
  IntObjectName = 'DCNotifyHistoryIO';
  MessageType = 'Integration Object';
  IntObjectFormat = 'Siebel Hierarchical';
  ListOfDCNotifyHistoryIO: NotificationHistoryListOfIO;

  constructor(login: string, options?: Partial<NotificationHistoryRequestOptions>) {
    this.ListOfDCNotifyHistoryIO = new NotificationHistoryListOfIO(login, options);
  }
}

export class NotificationHistoryListOfIO {
  'DC Notify History BC': NotificationHistoryRequestRecord;

  constructor(login: string, options?: Partial<NotificationHistoryRequestOptions>) {
    this['DC Notify History BC'] = new NotificationHistoryRequestRecord(login, options);
  }
}

export class NotificationHistoryRequestRecord {
  'DC Device Token ID' = '';
  Id = '';
  Created = '';
  Login = '';

  constructor(login: string, options?: Partial<NotificationHistoryRequestOptions>) {
    this.Login = login;
    this['DC Device Token ID'] = options?.deviceTokenId ?? '';
    this.Id = options?.id ?? '';
    this.Created = options?.created ?? '';
  }
}

export interface NotificationHistoryApiItem {
  Created?: string;
  'DC Title AR'?: string;
  'SR Number'?: string;
  'DC Notify Type'?: string;
  'SR Status'?: string;
  Id?: string;
  'DC Subject EN'?: string;
  'SR Type'?: string;
  'DC Subject AR'?: string;
  'DC Read Flag'?: string;
  'DC Download URL'?: string | null;
  'SR Sub Type'?: string;
  'DC Title EN'?: string;
  'DC Device Token ID'?: string;
  'DC Member Number'?: string | null;
  'DC Member Name Ara'?: string | null;
  'DC Member Name Eng'?: string | null;
  [key: string]: any;
}

export interface NotificationHistoryApiResponse {
  'Error Code'?: string | null;
  'Error Message'?: string | null;
  Language?: string;
  StartRowNum?: string;
  DCMethod?: string;
  TotalRecords?: string;
  PageSize?: string;
  NoDays?: string;
  NewQuery?: string;
  UnReadCount?: string;
  SiebelMessage?: {
    'DC Notify History BC'?: NotificationHistoryApiItem[] | NotificationHistoryApiItem;
    [key: string]: any;
  };
  [key: string]: any;
}

export interface NotificationHistoryPage {
  notifications: NotificationHistoryViewModel[];
  totalRecords: number;
}

export interface NotificationHistoryViewModel {
  id: string;
  heading: string;
  body: string;
  service: string;
  membershipName: string;
  memberNumber: string;
  srNumber: string;
  status: string;
  created: string;
  createdOnDate: Date | null;
  icon: 'info' | 'success' | 'warning' | 'error';
  highlight: boolean;
  downloadUrl: string | null;
  raw: NotificationHistoryApiItem;
  CSN: string | null;
}
